import { render, staticRenderFns } from "./pos-Purchase.vue?vue&type=template&id=a0d81b40"
import script from "./pos-Purchase.vue?vue&type=script&lang=js"
export * from "./pos-Purchase.vue?vue&type=script&lang=js"
import style0 from "./pos-Purchase.vue?vue&type=style&index=0&id=a0d81b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports